// @flow
import { RESORT_RESTAURANTS } from 'Client/cms/toolkit/constants';
import graphQLClient from 'Utils/graphql-client/graphqlClient';
import { buildProductArgs } from 'Utils/graphql';
import { LINE_PRODUCT_RESTAURANTS } from 'Utils/request/requestDictionary';

export type CMSProps = {
  resortId: string,
  title: string,
};

export type GQLProps = {
  restaurants: {
    introduction: {
      description: string,
    },
    restaurantsList: Array<{
      name: string,
      description: string,
      images: Array<string>,
    }>,
  },
  config: CMSContent,
};

export const productRestaurantsResolver = {
  name: RESORT_RESTAURANTS,
  resolve(
    appContext: AppContext,
    props: CMSProps,
    pageContext: PageContext,
    location: ProductRouterLocation,
  ): Promise<GQLProps> {
    const { urlParams } = location;
    const { resortId: productId } = props;
    const productArgs = buildProductArgs(productId, urlParams);

    const query = `query {
      restaurants(${productArgs}){
        introduction { description }
        restaurantsList { name images description }
      }
      config {
        common {
          viewMore
          loadLess
        }
      }
    }`;

    return graphQLClient.runQuery(query, appContext, {
      requestName: LINE_PRODUCT_RESTAURANTS,
      strictErrors: false,
    });
  },
};
